import { CompositionChildEditPreviewDto } from '@app/modules/compose/composition.types';
import { useState } from 'react';

import { getCompositionEditThumbnailSrc } from './get-composition-edit-thumbnail-src';
import { getCompositionListDefaultPreviewEditIndex } from './get-composition-list-default-preview-edit-index';

/**
 * Main preview index for a composition card: defaults to the last edit with a
 * thumbnail; hovering a strip item temporarily switches to that edit.
 */
export function useCompositionCardPreviewEdit(edits: CompositionChildEditPreviewDto[]) {
  const defaultIndex = getCompositionListDefaultPreviewEditIndex(edits);
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  const activeIndex = hoverIndex ?? defaultIndex;
  const activeEdit = activeIndex >= 0 ? edits[activeIndex] : undefined;
  const activeThumbnailSrc = activeEdit ? getCompositionEditThumbnailSrc(activeEdit) : null;

  function handleStripItemEnter(index: number) {
    setHoverIndex(index);
  }

  function handleStripLeave() {
    setHoverIndex(null);
  }

  return {
    activeIndex,
    activeThumbnailSrc,
    handleStripItemEnter,
    handleStripLeave,
  };
}
